import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/api";

const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

const AdminLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("fg_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-white border border-[#E5E5E5] px-5 py-3.5 text-sm text-forest placeholder:text-forest/40 focus:outline-none focus:border-forest transition-colors duration-300";

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-forest flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="mb-10">
          <p className="font-serif text-4xl text-cream font-semibold">Future Gen <span className="text-sm align-super text-cream/50">ASBL</span></p>
          <p className="mt-2 text-sm text-cream/60">Administration</p>
        </div>
        <form onSubmit={submit} className="bg-[#FAFAFA] p-8 md:p-10 flex flex-col gap-5" data-testid="admin-login-form">
          {error && <p data-testid="admin-login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-3">{error}</p>}
          <input data-testid="admin-email-input" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className={inputCls} />
          <input data-testid="admin-password-input" required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password" className={inputCls} />
          <button data-testid="admin-login-submit" disabled={loading} className="mt-2 inline-flex items-center justify-center gap-2 bg-forest text-cream px-8 py-4 font-medium hover:bg-clay transition-colors duration-300 disabled:opacity-60">
            Sign in <ArrowUpRight size={18} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
